import { render, staticRenderFns } from "./TaskItem.vue?vue&type=template&id=45b4a375&scoped=true&"
import script from "./TaskItem.vue?vue&type=script&lang=js&"
export * from "./TaskItem.vue?vue&type=script&lang=js&"
import style0 from "./TaskItem.vue?vue&type=style&index=0&id=45b4a375&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b4a375",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/m1292/Documents/develop/laravel/cure-naruhodoga/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45b4a375')) {
      api.createRecord('45b4a375', component.options)
    } else {
      api.reload('45b4a375', component.options)
    }
    module.hot.accept("./TaskItem.vue?vue&type=template&id=45b4a375&scoped=true&", function () {
      api.rerender('45b4a375', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/designed/user/TaskItem.vue"
export default component.exports